export enum MenuItemEnum {
  ATTEMPTS = 'ATTEMPTS',
  DASHBOARD = 'DASHBOARD',
  DEV_PATTERNS = 'DEV_PATTERNS',
  DICTIONARIES = 'DICTIONARIES',
  PATHS = 'PATHS',
  PROCESSES = 'PROCESSES',
  QUESTION_BANK = 'QUESTION_BANK',
  QUESTION_STATISTICS = 'QUESTION_STATISTICS',
  SETTINGS = 'SETTINGS',
  SURVEYS = 'SURVEYS',
  TESTS = 'TESTS',
}

export enum MenuSectionEnum {
  DEVELOPER = 'DEVELOPER',
  MODULES = 'MODULES',
  OVERVIEW = 'OVERVIEW',
  SYSTEM = 'SYSTEM',
}
